"use client";

import { Sparkles, Users, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/app/_module/components/ui/card";

const UPCOMING = [
  {
    icon: Users,
    title: "Free Leads from Vendors",
    description:
      "Earn free leads from top insurance lead vendors based on your referral tier.",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
  {
    icon: TrendingUp,
    title: "Bonus Multipliers",
    description:
      "Higher tiers will unlock bonus multipliers on all rewards earned.",
    color: "text-blue-600",
    bg: "bg-blue-50",
  },
];

export default function UpcomingRewardsTeaser() {
  return (
    <Card className="border-dashed border-indigo-200">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-indigo-500" />
          Coming Soon
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {UPCOMING.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 p-3 rounded-lg bg-gray-50/50"
            >
              <div
                className={`w-10 h-10 rounded-full ${item.bg} flex items-center justify-center flex-shrink-0`}
              >
                <item.icon className={`h-5 w-5 ${item.color}`} />
              </div>
              <div>
                <h4 className="font-semibold text-sm text-gray-900 mb-0.5">
                  {item.title}
                </h4>
                <p className="text-xs text-gray-500">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-400 mt-3 text-center">
          More rewards are on the way — keep climbing the tiers!
        </p>
      </CardContent>
    </Card>
  );
}
